export default {
  "common": {
    "all": "Tất cả",
    "cancel": "Hủy",
    "userAgreement": "thỏa thuận người dùng",
    "close": "Đóng",
    "submit": "Gửi",
    "submitting": "Đang gửi...",
    "report": "Báo cáo",
    "loading": "Đang tải...",
    "noMore": "Hết nội dung",
    "search": "Tìm kiếm",
    "today": "Hôm nay",
    "collapse": "Thu gọn",
    "retryLater": "Thử lại sau",
    "tips": "Mẹo",
    "friendlyReminder": "Mẹo thân thiện",
    "finish": "Hoàn thành",
    "noData": "Không có dữ liệu liên quan",
    "retry": "Thử lại",
    "reset": "Đặt lại",
    "confirm": "Xác nhận",
    "continue": "Tiếp tục",
    "notAvailableYet": "Chưa mở"
  },
  "tab": {
    "home": "Trang chủ",
    "card": "Thẻ",
    "mine": "Tài khoản của tôi"
  },
  "auth": {
    "loginTitle": "Ví Web3 Pay",
    "loginSubtitle": "A single card connects assets and consumption, effortlessly unlocking a global payment experience",
    "createWallet": "Tạo ví",
    "importWallet": "Toi da co vi",
    "choiceOneWay": "Choose a method to quickly start your secure digital asset journey",
    "iHaveWallet": "Toi da co vi",
    "choiceOneWay2": "Chon mot cach dang nhap de nhanh chong bat dau hanh trinh tai san so an toan",
    "createUseEmail": "Tao bang Email",
    "createUseRemWord": "Tao Vi Cum Tu Ghi Nho",
    "loginUseEmail": "Dang nhap bang Email",
    "loginByReWord": "Nhap bang Khoa rieng tu / Cum tu ghi nho",
    "validByEmail": "Xac minh nhanh qua email, don gian va tien loi",
    "validByReWord": "Duoc kiem soat hoan toan boi cum tu ghi nho, an toan va phi tap trung",
    "validByReWord2": "Nhap bang cum tu ghi nho/khoa rieng tu/dia chi vi",
    "emailLoginRegister": "Email Login/Register",
    "inviteRegisterTitleStart": "Chạm để thanh toán,",
    "inviteRegisterTitleEnd": "thật dễ dàng",
    "inviteRegisterStartRewards": "Mở Thưởng",
    "inviteRegisterWelcome": "Chào mừng đến với WinPay!",
    "agreePrefix": "By continuing to use, you agree to the WinPay Wallet's ",
    "privacyPolicy": "Privacy Policy",
    "and": " và ",
    "userAgreement": "thỏa thuận người dùng",
    "agreementMessage": "Please read the Privacy Policy and User Agreement first. Clicking 'Continue' indicates that you agree to the WinPay Wallet's Privacy Policy and User Agreement.",
    "agreementConfirm": "Đã đọc và đồng ý",
    "addEmailAddress": "Thêm email",
    "inputEmailAddress": "Nhap dia chi email",
    "emailAccountTip": "Email này sẽ là tài khoản đăng nhập của bạn.",
    "emailAddress": "Địa chỉ email",
    "email": "Email",
    "emailLogin": "Dang nhap Email",
    "enterEmail": "Nhập email của bạn",
    "enterEmailAddress": "Nhap dia chi email",
    "register": "Đăng ký",
    "login": "Đăng nhập",
    "enterVerificationCode": "Nhập mã",
    "codeSentTo": "Mã đã gửi tới ",
    "codeSentToEmail": "Mã đã được gửi đến email của bạn:",
    "codeValid": ", hiệu lực 10 phút.",
    "emailCode": "Mã email",
    "enterEmailCode": "Enter email code",
    "getCode": "Nhận mã",
    "resend": "Hantar Semula",
    "codeSent": "Mã đã được gửi",
    "codeSentValid": "*Mã đã gửi. Hiệu lực 10 phút",
    "cannotReceiveCode": "Không nhận được mã?",
    "checkSpamFolder": "Kiểm tra thư mục thư rác",
    "codeHelpTitle": "Không nhận được mã xác minh?",
    "codeHelpIntro": "Mã xác minh thường được gửi trong vòng 1 phút. Nếu bạn vẫn chưa nhận được:",
    "codeHelpEmailTitle": "Kiểm tra email có chính xác không",
    "codeHelpEmailDesc": "Vui lòng đảm bảo mã được gửi đến đúng địa chỉ email bạn dự kiến. Một lỗi chính tả nhỏ là nguyên nhân phổ biến nhất khiến mã không được gửi đến.",
    "codeHelpSpamTitle": "Kiểm tra thư mục thư rác",
    "codeHelpSpamDesc": "Email xác minh đôi khi bị đánh dấu là thư rác. Hãy đánh dấu email không phải thư rác để các mã tiếp theo có thể gửi đến hộp thư của bạn.",
    "codeHelpResendTitle": "Yêu cầu mã xác minh mới",
    "codeHelpResendDesc": "Vui lòng sử dụng mã xác minh mới nhất vì mã cũ sẽ hết hạn.",
    "verify": "Xác minh",
    "inputPassword": "Nhập mật khẩu",
    "setWalletPassword": "Thiết lập mật khẩu ví",
    "walletPasswordTip": "Set a password to manage your wallet. This password cannot be recovered. If you forget your password, you can go to my homepage - Security Settings - Retrieve Password, or log in again with your email and reset your payment password!",
    "setPasswordForTransaction": "Đặt mật khẩu ví để xác minh giao dịch.",
    "strongPassword": "Nhập một mật khẩu mạnh",
    "enterPasswordPlaceholder": "Vui lòng nhập mật khẩu",
    "enterPassword": "Nhập",
    "confirmPassword": "Nhập lại mật khẩu",
    "passwordTooShort": "*Password is too short. At least 8 characters.",
    "passwordWeak": "Mật khẩu yếu",
    "passwordMedium": "Mật khẩu trung bình",
    "passwordStrong": "Mật khẩu mạnh",
    "passwordMismatch": "Hai mật khẩu không khớp",
    "passwordError": "Sai mật khẩu",
    "bindEmail": "Kết nối email",
    "bindEmailIntro": "Để bảo mật tài sản của bạn, vui lòng kết nối email",
    "emailForRecovery": "Dùng để phục hồi mật khẩu",
    "emailRequired": "Email không thể để trống",
    "codeRequired": "Mã không thể để trống",
    "invitationCode": "Mã Mời",
    "enterInvitationCode": "Nhập mã mời (tùy chọn)",
    "verificationFailed": "Xác minh thất bại",
    "walletReady": "Wallet ready",
    "walletCreatedSuccess": "Welcome Back!",
    "walletExploreTip": "WinPay full functionality enabled",
    "firstExploreCreateTitle": "Wallet created successfully!",
    "firstExploreRegisterTitle": "Login successful!",
    "firstExploreLoginTitle": "Welcome back!",
    "firstExploreImportTitle": "Wallet imported successfully!",
    "firstExploreCreateSubtitle": "You can now explore the public-chain crypto wallet",
    "firstExploreDefaultSubtitle": "WinPay full functionality enabled",
    "startExplore": "Bắt đầu khám phá",
    "importTitle": "Nhập cụm từ ghi nhớ hoặc khóa cá nhân",
    "importWalletTip": "Separate mnemonic words with spaces. Supports importing from any wallet.",
    "importPlaceholder": "Nhập cụm từ ghi nhớ hoặc khóa cá nhân",
    "importInvalid": "Invalid input",
    "importTip1": "WinPay Wallet does not store your mnemonic or private key. You control your assets.",
    "importTip2": "Make sure no one else or camera can see your secret.",
    "importTip3": "Khuyến nghị bạn tự nhập hoặc quét mã QR để nhập cụm từ ghi nhớ hoặc khóa cá nhân của bạn.",
    "continue": "Tiếp tục",
    "backupWarnTitle": "Nhớ kỹ trước khi sao lưu!",
    "backupTipWrite": "Khuyến nghị viết tay",
    "backupTipNoCopy": "Không sao chép và lưu lại",
    "backupTipNoScreenshot": "Không chụp màn hình để lưu",
    "backupWarn1Title": "Cụm từ gợi nhớ tương đương với mật khẩu ví của bạn",
    "backupWarn1Desc": "Anyone with your mnemonic controls your assets. Leaks are irreversible.",
    "backupWarn2Title": "Hãy viết tay hoặc lưu trữ trên ví lạnh hoặc các thiết bị ngoại tuyến khác",
    "backupWarn2Desc": "Nếu sao chép hoặc chụp màn hình lưu lại, cụm từ gợi nhớ có thể bị lộ",
    "backupWarn3Title": "Hãy lưu cụm từ gợi nhớ ở nơi an toàn",
    "backupWarn3Desc": "Một khi bị mất, tài sản sẽ không thể khôi phục lại",
    "backupWarnCheck": "You are responsible for your mnemonic. Back it up — loss means permanent asset loss.",
    "backupMnemonic": "Sao lưu cụm từ khóa",
    "mnemonicDesc": "Cụm từ khôi phục là mật khẩu ví của bạn. Hãy lưu giữ an toàn.",
    "verifyMnemonicTitle": "Xác minh mnemonic",
    "verifyMnemonicTip": "Hãy xác nhận cụm từ gợi nhớ theo thứ tự",
    "ordinalNumber": "Word {number}",
    "mnemonicCheckFailed": "Xác minh cụm từ ghi nhớ thất bại",
    "mnemonicCheckSuccess": "Xác minh cụm từ ghi nhớ thành công",
    "mnemonicUnavailable": "No mnemonic backup available for this wallet",
    "verifyWalletPassword": "Enter payment password",
    "forgotPasswordRecovery": "Quên mật khẩu? Đặt lại",
    "resetPaymentPassword": "Phục hồi mật khẩu",
    "resetPaymentPasswordTip": "Verify your bound email first, then reset the payment password",
    "changePassword": "Thay đổi mật khẩu",
    "currentPassword": "Mật khẩu hiện tại",
    "enterCurrentPassword": "Nhập mật khẩu hiện tại",
    "setPassword": "Đặt mật khẩu",
    "pleaseSetNewPasswordMin8": "Đặt mật khẩu mới từ 8 ký tự trở lên",
    "newPassword": "Mật khẩu mới",
    "setNewPasswordMin8": "Set a new password with at least 8 characters",
    "enterNewPassword": "Nhập mật khẩu mới",
    "confirmNewPassword": "Xác nhận mật khẩu mới",
    "setNewPasswordAgain": "Xác nhận lại mật khẩu mới đã đặt",
    "currentPasswordIncorrect": "Mật khẩu hiện tại không chính xác",
    "newPasswordSameAsOld": "Mật khẩu mới không thể trùng mật khẩu cũ",
    "passwordsNotMatch": "Mật khẩu mới không khớp",
    "passwordOnlySavedLocally1": "Tôi hiểu rằng mật khẩu chỉ được lưu trữ trên thiết bị này,",
    "passwordOnlySavedLocally2": "và không thể khôi phục khi quên.",
    "noBoundEmailRecover": "Bạn chưa kết nối email, không thể phục hồi mật khẩu",
    "goBindEmail": "Kết nối email",
    "boundEmail": "Xác nhận email",
    "changeSuccess": "Thay đổi thành công",
    "bindEmailTip": "Vui long lien ket email truoc khi lay lai mat khau",
    "bindEmailTip2": "Liên kết email trước khi khôi phục mật khẩu để nhận mã xác minh.",
    "bindEmailTip3": "Vui lòng liên kết email trước",
    "noBindEmail": "Không",
    "canUseWallet": "Xin chúc mừng, bạn có thể sử dụng ví ngay bây giờ!",
    "successfullyProtected": "Bạn đã bảo vệ ví của mình thành công. Hãy nhớ giữ an toàn từ khóa khôi phục vì nếu mất, bạn sẽ không thể khôi phục lại! Bạn có thể sao lưu bất kỳ lúc nào bằng cách vào Cài đặt → Quản lý Ví → Chọn Ví → Xuất Từ khóa khôi phục.",
    "startUseApp": "Bắt đầu sử dụng WinPay Wallet",
    "next": "Tiếp theo"
  },
  "home": {
    "title": "Trang chủ",
    "totalAssets": "Tổng tài sản",
    "receive": "Nhận được",
    "scan": "Quét",
    "transfer": "Chuyển khoản",
    "topup": "Nạp tiền",
    "withdraw": "Rút tiền",
    "bill": "Lịch sử",
    "invite": "Mời bạn",
    "invitCode": "Mã QR mời",
    "more": "Thêm",
    "recent": "Shortcuts",
    "community": "Cộng đồng",
    "token": "Token",
    "turnover": "Doanh thu",
    "nft": "NFT",
    "accountAssets": "Tài sản trong tài khoản",
    "cardAssets": "Tài sản trong thẻ",
    "cardWallet": "Thẻ",
    "backup": "Đi sao lưu",
    "winpayCardPayment": "WinPay Virtual Card + Physical Card Dual Payment Support",
    "applyExclusiveCard": "Đăng ký thẻ độc quyền",
    "nodeFast": "Node OK",
    "nodeSlow": "Node Slow",
    "nodeBad": "Node Error",
    "node": "Node",
    "viewAccount": "Chọn tài khoản",
    "selectAccount": "Chọn tài khoản",
    "selectNode": "Chọn node",
    "blockHeightExplain": "Lower latency and newer block height usually mean a better node connection.",
    "recommendNode": "Nút được đề xuất",
    "blockHeight": "Chiều cao khối",
    "currentAccountNotSupport": "The current account does not support this network.",
    "noData": "Không có dữ liệu",
    "actionTodo": "Chưa mở",
    "cardTailNo": "Số cuối cùng",
    "tradeSuccess": "Giao dịch thành công",
    "tradeFailed": "Giao dịch thất bại",
    "kycRetryRequired": "Xác minh KYC thất bại. Vui lòng xác minh lại.",
    "viewNow": "Xem ngay"
  },
  "wallet": {
    "chooseCoin": "Chọn loại coin khác",
    "chooseNetwork": "Chọn mạng",
    "copyAddress": "Sao chép địa chỉ",
    "copySuccess": "Sao chép thành công",
    "copyFailed": "Sao chép không thành công",
    "saveSuccess": "Lưu thành công",
    "saveFailed": "Save failed",
    "depositAddress": "Deposit Address",
    "topupNotes": "Lưu ý:",
    "topupNote1Prefix": "1. Số tiền nạp được tính bằng",
    "topupNote1Highlight1": "‘số tiền thực tế nhận được’",
    "topupNote1Middle": "theo quy định, khác nhau giữa các nền tảng",
    "topupNote1Highlight2": "‘số tiền thực tế nhận được’",
    "topupNote1Suffix": " may differ across platforms because outgoing platform fees are deducted before arrival.",
    "topupNote2": "2. Do not deposit any non-USDT assets to the address above, or the assets may not be recoverable.",
    "topupNote3": "3. After depositing to the address above, network confirmation is required. Funds arrive after 60 confirmations and can be withdrawn after 910 confirmations.",
    "withdrawAddress": "Withdraw Address",
    "enterWithdrawAddress": "Nhập địa chỉ rút tiền",
    "withdrawAmount": "Withdraw Amount",
    "withdrawAmountLabel": "Số lượng",
    "maxAmountLabel": "Maximum Amount",
    "available": "Có sẵn",
    "enterAmount": "Nhập số lượng",
    "enterWithdrawAmount": "Nhập số tiền rút",
    "all": "Tất cả",
    "fee": "Phí",
    "received": "Dự kiến nhận được",
    "submitWithdraw": "Gửi yêu cầu rút tiền",
    "withdrawNotes": "Lưu ý:",
    "withdrawNote1Prefix": "1. Minimum withdrawal amount is ",
    "withdrawNote2": "2. Please ensure the withdrawal address is accurate, otherwise assets cannot be recovered.",
    "withdrawNote3Prefix": "3. Sau khi được phê duyệt",
    "withdrawNote3Suffix": "tiền sẽ vào tài khoản trong vòng vài giờ. Có thể có độ trễ do nguyên nhân mạng",
    "withdrawNote4": "4. Nếu lâu không nhận được, vui lòng liên hệ với dịch vụ khách hàng để kiểm tra",
    "withdrawUnavailable": "Rút tiền hiện chưa mở",
    "withdrawConfirm": "Confirm withdrawal?",
    "withdrawSuccess": "Yêu cầu rút tiền đã được gửi thành công, vui lòng chờ quản trị viên phê duyệt",
    "billTitle": "Lịch sử",
    "billDetailTitle": "Chi tiết",
    "noBill": "No records",
    "noBillDetail": "Chưa có dữ liệu liên quan",
    "assetType": "Loại",
    "recordType": "Record Type",
    "billTimeLabel": "Thời gian",
    "choosePricingFiat": "Chọn đơn vị tiền tệ định giá",
    "hotFeatures": "Tính năng nổi bật",
    "moreFeatures": "Thêm tính năng",
    "walletFeatures": "Tính năng nổi bật",
    "cardFeatures": "Tính năng thẻ",
    "otherFeatures": "Tính năng khác",
    "payment": "Nhận được",
    "scanCode": "Quét",
    "walletBackup": "Sao lưu ví",
    "openCard": "Mở thẻ ngay",
    "GoOpenCard": "Go open the card",
    "physicalCard": "Tính năng thẻ vật lý",
    "physicalUnavailable": "The physical card feature is temporarily unavailable. Stay tuned!",
    "activateCard": "Kích hoạt thẻ vật lý",
    "physicalTransfer": "Physical Transfer",
    "fundTransfer": "Chuyển Khoản",
    "fundTransferUnavailable": "Tính năng này chưa được mở. Vui lòng chờ cập nhật!",
    "receiveAddress": "Địa chỉ nhận",
    "saveCollectionCode": "Lưu mã thu",
    "transferInProperty": "Only transfer assets through {network}",
    "receiveTips": "Receive Tips",
    "receiveTip1": "Confirm the asset and current network before receiving.",
    "receiveTip2": "Wrong network or coin transfers may not be recoverable.",
    "openCamera": "Open Camera",
    "closeCamera": "Close Camera",
    "pasteScanResult": "Paste or enter scan result",
    "scanResult": "Scan Result",
    "cameraUnavailable": "Camera is unavailable in this browser",
    "cameraPermissionDenied": "Camera access is blocked. Please allow camera permission first.",
    "cameraPermissionHint": "If no permission prompt appears, check whether camera access is allowed in site permissions.",
    "cameraNotFound": "No camera device was found.",
    "cameraInUse": "Camera is currently being used by another app. Please close it and try again.",
    "cameraConstraintFailed": "The requested camera mode is not supported on this device, and fallback also failed.",
    "cameraSecureContextRequired": "This page is not running in a camera-safe browser context.",
    "cameraSecureContextHint": "On Android browsers, webpage camera access usually requires HTTPS or localhost. Using a LAN http address often will not trigger camera permission directly.",
    "cameraGuideTitle": "Unable to open camera",
    "iosCameraGuideTitle": "iPhone camera guide",
    "androidCameraGuideTitle": "Android camera guide",
    "cameraPermissionGuide": "1. In iPhone Safari, tap the \"aA\" button or the page menu near the address bar.<br/>2. Open Website Settings and change Camera to Allow.<br/>3. Return to this page, refresh it, and tap scan again.<br/>4. If you previously tapped \"Don’t Allow\", also check camera access in iPhone Settings for Safari.",
    "cameraSecureGuide": "This page must be opened in a secure context to access the camera.<br/>1. Make sure you are using the official domain or a secure link.<br/>2. Refresh the page and try again.<br/>3. If it still fails, reopen it in the system browser.",
    "cameraUnavailableGuide": "1. First make sure the iPhone camera works normally in the system Camera app.<br/>2. Check whether camera access is allowed for this website in Safari.<br/>3. Close any other app that may be using the camera, then try again.<br/>4. If it still fails, refresh the page or re-enter and retry.",
    "iosCameraPermissionGuide": "1. In iPhone Safari, tap the \"aA\" button or the page menu near the address bar.<br/>2. Open Website Settings and change Camera to Allow.<br/>3. Return to this page, refresh it, and tap scan again.<br/>4. If you previously tapped \"Don’t Allow\", also check camera access in iPhone Settings for Safari.",
    "iosCameraSecureGuide": "This page must be opened in a secure context to access the camera.<br/>1. Make sure you are using the official domain or a secure link.<br/>2. Refresh the page and try again.<br/>3. If it still fails, reopen it in the system browser.",
    "iosCameraUnavailableGuide": "1. First make sure the iPhone camera works normally in the system Camera app.<br/>2. Check whether camera access is allowed for this website in Safari.<br/>3. Close any other app that may be using the camera, then try again.<br/>4. If it still fails, refresh the page or re-enter and retry.",
    "androidCameraPermissionGuide": "1. Open Site Settings or Permissions in your Android browser for this website.<br/>2. Change Camera permission to Allow.<br/>3. If the system camera permission was denied before, open Android Settings - Apps - Browser - Permissions and allow Camera.<br/>4. Return to the page, refresh it, and tap scan again.",
    "androidCameraSecureGuide": "Most Android browsers require a secure context for camera access.<br/>1. Make sure the page is opened from the official domain or an HTTPS link.<br/>2. If you are using a LAN address, many Android browsers will not trigger camera permission.<br/>3. Switch to the official address, refresh the page, and try again.",
    "androidCameraUnavailableGuide": "1. First make sure the system Camera app works normally on your phone.<br/>2. Check that both the browser and Android system allow camera permission.<br/>3. Close other apps that may be using the camera and try again.<br/>4. If it still fails, refresh the page or try the system browser.",
    "androidScanGuideTitle": "Android scan guide",
    "androidScanGuide": "The camera is open, but this Android browser does not support the live scanning capability used on this page.<br/>1. Try the system browser or the latest Chrome first.<br/>2. Make sure camera permission is allowed for this website.<br/>3. Refresh the page and try again. If it still fails, switch to a browser that supports live web scanning.",
    "safariScanGuideTitle": "Safari scan guide",
    "safariScanGuide": "The camera is open, but iPhone Safari does not support the live scanning capability used on this page.<br/>1. First confirm camera permission is allowed for this website.<br/>2. Refresh the page and try once more.<br/>3. If it still cannot scan, please use a browser that supports live web scanning or complete scanning from another entry.",
    "scanNotSupportedGuide": "This browser does not support the live scanning capability used on this page.<br/>1. Make sure camera permission is already allowed for this website.<br/>2. Refresh the page and try once more.<br/>3. If it still fails, please switch to the system browser or another browser that supports live web scanning.",
    "scanNotSupported": "This browser does not support live QR scanning. Please try again in your system browser.",
    "scanSuccess": "Scanned",
    "transferRecord": "Ghi chú giao dịch tài khoản",
    "directTransfer": "Chuyển tiền trực tiếp",
    "addressBookTransfer": "Chuyển tiền địa chỉ",
    "scanTransfer": "Chuyển tiền quét mã",
    "enterOrPasteAddress": "Enter or paste address",
    "transferAmount": "Số tiền chuyển",
    "transferHistory": "Lịch sử chuyển tiền",
    "noTransferRecord": "No transfer records",
    "transferConfirm": "Confirm transfer?",
    "addToken": "Thêm token",
    "addNft": "Thêm NFT",
    "nftDetail": "Chi tiết NFT",
    "nftAssets": "Số dư",
    "nftAssetView": "NFT",
    "nftSendTitle": "Gửi NFT",
    "nftSendAsset": "Số dư",
    "sendNft": "Gửi",
    "removeNft": "Xóa",
    "invalidAddress": "Please enter a valid address",
    "nftTransferUnsupported": "NFT transfer is not supported on the current network",
    "nftSendSuccess": "Đã gửi thành công",
    "hotToken": "Token phổ biến",
    "hotNft": "NFT phổ biến",
    "customToken": "Token tùy chỉnh",
    "customNft": "NFT tùy chỉnh",
    "enterContractAddressSearch": "Enter contract address to search",
    "tokenAddress": "Địa chỉ token",
    "nftAddress": "NFT Address",
    "enterTokenAddress": "Nhập địa chỉ token",
    "enterNftAddress": "Enter NFT contract address",
    "tokenSymbol": "Ký hiệu token",
    "enterTokenSymbol": "Nhập ký hiệu token",
    "decimalPlaces": "Số chữ số thập phân",
    "tokenAdded": "Token đã được thêm vào",
    "addSuccess": "Thêm thành công",
    "tokenDetail": "Chi tiết Token",
    "propertyBalance": "Số dư tài sản",
    "transferIn": "Chuyển vào",
    "transferOut": "Chuyển ra",
    "transferInAddress": "Địa chỉ chuyển vào",
    "transferOutAddress": "Địa chỉ chuyển",
    "transactionId": "ID giao dịch",
    "blockchainBrowser": "Trình duyệt Blockchain",
    "network": "Mạng",
    "pending": "Đang xử lý",
    "inTransaction": "Đang giao dịch",
    "finish": "Hoàn thành",
    "signTodo": "Signing flow migration in progress",
    "exportMnemonic": "Xuất câu ghi nhớ",
    "exportPrivateKey": "Xuất khóa riêng tư",
    "sensitiveExportLabel": "Identity verification required",
    "securityReminder": "Lời Nhắc An Toàn",
    "backupTip1": "Mnemonic and private key control your assets. Keep them offline.",
    "backupTip2": "Do not screenshot, record, or send them to anyone.",
    "backupTip3": "WinPay never stores your mnemonic or private key.",
    "backupSensitiveConfirm": "Make sure your surroundings are secure before continuing.",
    "sensitiveExportTodo": "Sensitive export flow migration in progress",
    "privateKeyUnavailable": "No private key export available for this wallet",
    "specialReminder": "Nhắc nhở đặc biệt",
    "safetyReminder": "Lời Nhắc An Toàn",
    "privateCarefulExport": "After exporting the private key, store it offline with extreme care. Exposure may lead to asset loss.",
    "clickShowPrivateKeyQr": "Nhấp để hiển thị mã QR khóa riêng tư",
    "plaintextPrivateKey": "Khóa Riêng Tư Văn Bản Thường",
    "copyPrivateKey": "Sao chép Khóa Riêng Tư",
    "copyPrivateKeyAfter": "After copying the private key, be sure to store it properly, otherwise it may cause asset loss.",
    "copyMnemonicAfter1": "Vui lòng ghi ra giấy",
    "copyMnemonicAfter2": "Khuyến nghị lưu trữ trên giấy.",
    "copyMnemonicAfter3": "Hãy nhập đúng thứ tự để tiếp tục.",
    "notPasteMnemonic1": "Không lưu cụm từ ghi nhớ trong môi trường mạng.",
    "notPasteMnemonic2": "mnemonic của bạn vào ứng dụng kết nối Internet,",
    "notPasteMnemonic3": "Không dán vào bất kỳ môi trường trực tuyến nào.",
    "notPasteMnemonic4": "dịch vụ lưu trữ trực tuyến hoặc công cụ nhắn tin",
    "notShareMnemonic1": "Không bao giờ chia sẻ mnemonic của bạn với bất kỳ ai,",
    "notShareMnemonic2": "chúng tôi sẽ không bao giờ yêu cầu mnemonic của bạn",
    "winpayCard": "WinPay Card",
    "openCardTitle": "Mở thẻ ngay",
    "openCardDesc": "Connect account assets with global payments",
    "openCardProcess": "Open Card Flow",
    "openCardStep1": "Xác minh KYC",
    "openCardStep2": "Chọn thẻ",
    "openCardStep3": "Kích hoạt",
    "cardSecure": "An toàn",
    "cardSecureDesc": "Risk controls",
    "cardGlobal": "Global",
    "cardGlobalDesc": "Multi-scenario payments",
    "cardAsset": "Số dư",
    "cardAssetDesc": "Unified balance",
    "openCardNow": "Mở thẻ ngay",
    "cardKycTodo": "Card KYC flow migration in progress",
    "activatePhysicalCard": "Kích hoạt thẻ vật lý",
    "activatePhysicalCardEntry": "Kích hoạt thẻ vật lý",
    "activatePhysicalDesc": "Enter card number and activation code after receiving the card",
    "cardNumber": "Số thẻ",
    "enterCardNumber": "Enter card number",
    "activeCode": "Mã kích hoạt",
    "enterActiveCode": "Enter activation code",
    "emailCode": "Mã email",
    "enterEmailCode": "Enter email code",
    "sendCode": "Send Code",
    "activateNow": "Activate Now",
    "activateTip1": "Activate only after receiving the physical card.",
    "activateTip2": "Check card number, email code, and activation code before submitting.",
    "cardApiTodo": "Card API migration in progress",
    "completeCardActiveForm": "Complete activation information",
    "activateSuccess": "Activated",
    "submitSuccess": "Submitted successfully",
    "physicalTransferDesc": "Balance transfer between physical cards",
    "fromCard": "From Card",
    "selectCard": "Chọn",
    "toCard": "To Card",
    "enterTargetCard": "Enter target card number",
    "remark": "Ghi chú",
    "optionalRemark": "Optional",
    "completePhysicalTransferForm": "Complete transfer information",
    "transferFrom": "Từ",
    "transferTo": "Đến",
    "fundingAccount": "Tài khoản quỹ",
    "exchangeCoin": "Exchange Asset",
    "availableBalance": "Available Balance",
    "transferInAmount": "Transfer In Amount",
    "transferOutAmount": "Transfer Out Amount",
    "withdrawFeeLabel": "Phí rút tiền",
    "failed": "Thất bại"
  },
  "invite": {
    "title": "Mời bạn",
    "inviteNow": "Mời ngay",
    "share": "Chia sẻ",
    "claim": "Nhận",
    "claimSuccess": "Đã nhận",
    "pendingClaim": "Có thể nhận",
    "claimableAmount": "Có thể nhận (USDT)",
    "claimed": "Đã nhận",
    "expired": "Đã hết hạn",
    "copyUrl": "Sao chép link",
    "saveQrCode": "Lưu QR",
    "saveImage": "Lưu",
    "posterTitle": "Một Thẻ · Thanh Toán Toàn Cầu",
    "posterTagline": "Thanh Toán Toàn Cầu · Một Ví",
    "pointsRules": "Quy tắc mời",
    "referralStepsTitle": "Bước giới thiệu",
    "pointsRulesComingSoon": "Sắp có",
    "heroTitle": "Thưởng giới thiệu",
    "hero1": "Giới thiệu & Nhận đến",
    "hero2": "60%",
    "hero3": "Thưởng",
    "heroDesc": "Xem thể lệ & Nhận thưởng",
    "partner": "Đối tác",
    "partnerPromotion": "Trở thành Đối tác WinPay. Kiếm nhiều hơn.",
    "partnerJoinNow": "Tham gia ngay",
    "coursePromotionTitle": "Bước giới thiệu",
    "purchaseCardToInvite": "Mở thẻ để mở khóa lời mời",
    "purchaseCardToInviteDesc": "Bạn đã hoàn tất xác minh danh tính. Sau khi mua thẻ ảo hoặc thẻ vật lý, bạn sẽ nhận được mã mời và liên kết mời riêng để bắt đầu nhận thưởng giới thiệu.",
    "unlockInviteTitle": "Điều kiện mở khóa mã và liên kết mời:",
    "unlockInviteDesc": "Mua bất kỳ thẻ nào để nhận mã và liên kết mời riêng của bạn.",
    "purchaseCardToInviteLater": "Để sau",
    "purchaseCardToInviteNow": "Mua thẻ ngay",
    "kycPurchaseCardDesc": "Vui lòng hoàn tất xác minh danh tính, sau đó mua thẻ ảo hoặc thẻ vật lý để mở khóa tính năng này.",
    "coursePromotionDesc": "Xem cách mời & nhận thưởng",
    "cardOpeningCommission": "Hoa hồng khi mời bạn bè mở thẻ",
    "cardOpeningCommissionShort": "Hoa hồng mở thẻ",
    "spendingCommission": "Hoa hồng chi tiêu",
    "commissionRefundDeduction": "Khấu trừ hoa hồng do hoàn tiền",
    "reservedReward": "Dự phòng",
    "courseCommission": "Hoa hồng mở thẻ cấp 2",
    "globalDirectorCourseCommission": "Hoa hồng mở thẻ cấp 2 dành cho Giám đốc Toàn cầu duy nhất",
    "globalDirectorCardOpeningCommission": "Hoa hồng mở thẻ dành cho Giám đốc Toàn cầu duy nhất",
    "teamBonusPoolCardOpeningCommission": "Hoa hồng mở thẻ từ quỹ thưởng đội nhóm",
    "teamBonusPoolCourseCommission": "Hoa hồng mở thẻ cấp 2 từ quỹ thưởng đội nhóm",
    "globalDirectorTeamCardOpeningCommission": "Hoa hồng mở thẻ đội nhóm dành cho Giám đốc Toàn cầu duy nhất",
    "globalDirectorTeamCourseCommission": "Hoa hồng mở thẻ cấp 2 đội nhóm dành cho Giám đốc Toàn cầu duy nhất",
    "inviteFriendCardOpeningCommission": "Hoa hồng khi mời bạn bè mở thẻ",
    "invitationCommission": "Giới thiệu",
    "purchaseCommission": "Mở thẻ",
    "consumptionCommission": "HH Cấp 2",
    "friendCourseCommission": "Hoa hồng mở thẻ cấp 2 của bạn bè",
    "inviteFriendCourseCommission": "Hoa hồng mở thẻ cấp 2 từ bạn bè được mời",
    "monthlyCommission": "Tháng",
    "monthlyBonusPoolCommission": "Thưởng nhóm",
    "globalDirectorExclusiveCommission": "Hoa hồng độc quyền dành cho Giám đốc Toàn cầu duy nhất",
    "globalDirectorCardOpeningReward": "Phần thưởng mở thẻ dành cho Giám đốc Toàn cầu duy nhất",
    "monthlyCommissionTitle": "Nhóm",
    "monthlyCommissionIntro": "Tích lũy hơn 5 lượt mở thẻ hợp lệ từ người được giới thiệu trực tiếp để đủ điều kiện nhận thưởng đội nhóm V3.",
    "monthlyCommissionTip1": "Quyết toán hoa hồng mở thẻ",
    "monthlyCommissionTip1Desc": "Sau khi đạt V3, mời bạn bè hoàn tất việc mở thẻ hợp lệ để nhận thưởng.",
    "monthlyCommissionTip2": "Phần thưởng theo cấp",
    "monthlyCommissionTip2Desc": "Quyết toán nửa tháng một lần; cấp T tương ứng được xác định theo số lượt giới thiệu trực tiếp hợp lệ.",
    "monthlyCommissionTip3": "Thông tin thưởng nhóm",
    "monthlyCommissionTip3Desc": "Sau khi bạn bè hoàn tất mua khóa học hợp lệ, khoản này sẽ đóng góp vào quỹ thưởng nhóm nửa tháng.",
    "monthlyCommissionTip4": "Quyết toán thưởng nhóm",
    "monthlyCommissionTip4Desc": "Quyết toán nửa tháng một lần; số tiền cụ thể căn cứ theo kết quả quyết toán cuối cùng của hệ thống.",
    "consumptionRefund": "Hoa hồng mời bạn bè mở thẻ",
    "friendConsumptionRewardRefund": "Hoàn thưởng bạn",
    "rewardRecordCardOpeningTitle": "[Bạn bè-{friendName}] hoa hồng mở thẻ",
    "rewardRecordConsumptionTitle": "[{friendName}] chi tiêu",
    "rewardRecordRefundTitle": "[{friendName}] hoàn tiền",
    "rewardRecordCourseCommissionTitle": "[Bạn bè-{friendName}] hoa hồng mở thẻ cấp 2",
    "rewardRecordFriendCourseCommissionTitle": "Mời [{friendName}] - hoa hồng mở thẻ cấp 2 của bạn bè",
    "rewardRecordMonthlyCommissionTitle": "[{friendName}] hoa hồng hàng tháng",
    "rewardRecordMonthlyBonusPoolTitle": "[{friendName}] hoa hồng quỹ thưởng hàng tháng",
    "rewardRecordRegistrationTitle": "Mời [{friendName}]",
    "invitationTotal": "Giới thiệu",
    "notUnlocked": "Chưa mở khóa",
    "purchaseCommissionTitle": "Thưởng thẻ",
    "purchaseCommissionIntro": "Nhận hoa hồng khi bạn bè kích hoạt Thẻ WinPay.",
    "purchaseCommissionTip1": "Cấp càng cao, tỷ lệ hoa hồng càng cao. ",
    "purchaseCommissionTip1Desc": "Hãy mời thêm bạn bè mở thẻ; khi đủ điều kiện, bạn có thể tham gia quỹ thưởng nhóm.",
    "purchaseCommissionTip2": "Thẻ ảo và thẻ vật lý nhận cùng mức hoa hồng sau khi kích hoạt.",
    "purchaseCommissionTip2Desc": "",
    "purchaseCommissionTip3": "Thưởng mở thẻ tự quyết toán",
    "purchaseCommissionTip3Desc": "Trả trong 3 ngày làm việc.",
    "purchaseCommissionTip3DescPrefix": "Trả trong ",
    "purchaseCommissionTip3Time": "Mở thẻ thành công, hoa hồng được quyết toán ngay.",
    "purchaseCommissionTip3DescSuffix": ". Phần thưởng sẽ tự động được chuyển vào tài khoản tổng tài sản của bạn.",
    "purchaseCommissionConfirm": "Tôi đã biết",
    "consumptionCommissionTitle": "Hoa hồng giới thiệu cấp 2",
    "consumptionCommissionIntro": "Khi người dùng bạn mời tiếp tục mời người dùng mới, bạn sẽ nhận thêm phần thưởng 25% từ nền tảng dựa trên hoa hồng mà người dùng mới tạo ra.",
    "consumptionCommissionTip1": "Quy tắc thưởng chi tiêu",
    "consumptionCommissionTip1Desc": "Ví dụ: A mời B, B mời C. Nếu C tạo ra 25 USDT hoa hồng cho B, A sẽ nhận thêm 6,25 USDT phần thưởng từ nền tảng.",
    "consumptionCommissionTip2": "Quy tắc hoàn tiền",
    "consumptionCommissionTip2Desc": "Hoàn tiền 30 ngày: không có thưởng.",
    "consumptionCommissionTip2Partial": "Hoàn một phần",
    "consumptionCommissionTip2PartialDesc": "Tính lại theo chi tiêu hợp lệ.",
    "consumptionCommissionTip3": "Hoàn tiền sau khi trả thưởng",
    "consumptionCommissionTip3Desc": "Đơn hoàn hoặc hủy có thể bị thu hồi thưởng đã trả.",
    "points": "Điểm của tôi",
    "inviteMethod": "Cách mời",
    "invitationCode": "Mã mời",
    "shareQr": "QR mời",
    "invitationLink": "Link mời",
    "myExclusiveInvite": "Giới thiệu của tôi",
    "invitationCodeShort": "Mã mời",
    "invitationLinkShort": "Liên kết",
    "invitationRelationTip": "Dùng mã/link để liên kết và nhận thưởng.",
    "recommender": "Người giới thiệu",
    "enterRecommenderCode": "Nhập mã",
    "scanRecommenderCode": "Quét mã",
    "viewFullRecords": "Xem tất cả",
    "personUnit": "người",
    "invitedFriendsTotal": "Tổng giới thiệu hợp lệ",
    "pendingCommission": "Thưởng chờ xử lý",
    "totalCommission": "Tổng thưởng",
    "parentCode": "Người mời",
    "enterParentCode": "Nhập mã mời",
    "bind": "Kết nối",
    "bound": "Đã liên kết",
    "rewardDetails": "Chi tiết thưởng",
    "commissionDetails": "Chi tiết hoa hồng",
    "recommendedUsers": "Người được mời",
    "tradingFriends": "Bạn bè giao dịch",
    "registeredFriends": "Bạn bè đăng ký",
    "noRecommendedUsers": "Chưa có người được mời",
    "totalCommissionUsdt": "Tổng thưởng（USDT）",
    "withdrawable": "Có thể nhận",
    "pendingSettlement": "Đang chờ",
    "pendingSettlementTitle": "Chờ quyết toán (USDT)",
    "pendingSettlementDescription": "Quyết toán trước khi nhận; hoàn tiền sẽ thu hồi thưởng.",
    "pendingSettlementQuestion": "Khi nào quyết toán?",
    "pendingSettlementMonthlyCommission": "Hoa hồng nhóm: quyết toán nửa tháng một lần",
    "pendingSettlementCardActivation": "Kích hoạt thẻ: hoa hồng được quyết toán và ghi có ngay sau khi thẻ được kích hoạt thành công",
    "pendingSettlementTransaction": "Hoa hồng mở thẻ cấp 2: được quyết toán và ghi có ngay sau khi mua hàng được xác minh",
    "settled": "Đã hoàn tất",
    "myRewards": "Thưởng của tôi",
    "date": "Ngày",
    "selectDate": "Chọn ngày",
    "rewardSuccess": "Thành công",
    "rewardReady": "Có thể nhận",
    "rewardVoided": "Đã hủy",
    "rewardPartialRefund": "Hoàn một phần",
    "rewardRefunded": "Đã hoàn tiền",
    "rewardDeducted": "Đã khấu trừ",
    "rewardDeductionFailed": "Khấu trừ thất bại",
    "rewardCredited": "Đã ghi có",
    "rewardCardType": "Loại thẻ",
    "rewardType": "Loại thưởng",
    "friendNickname": "Tên bạn",
    "invitationRelation": "Quan hệ giới thiệu",
    "indirectFriend": "Bạn được giới thiệu gián tiếp",
    "rewardAmount": "Tiền thưởng",
    "percentageWeight": "Tỷ trọng phần trăm",
    "deductionAmount": "Tiền trừ",
    "commissionAllocationRatio": "Tỷ lệ phân bổ",
    "commissionAllocationRatioUnavailable": "Chưa có dữ liệu",
    "commissionSettlementCycle": "Chu kỳ quyết toán",
    "teamCommissionSettlementCycle": "Quyết toán nửa tháng một lần",
    "commissionSettlementMethod": "Phương thức quyết toán",
    "commissionInstantSettlement": "Ghi có ngay",
    "commissionTriggerTime": "Thời gian kích hoạt",
    "commissionSettlementTime": "Thời gian quyết toán",
    "friendConsumptionRefundTime": "Thời gian bạn hoàn tiền",
    "commissionDeductionTime": "Thời gian khấu trừ",
    "commissionStatus": "Trạng thái",
    "rewardDetailsAmountPrefix": "Chi tiết thưởng ",
    "balanceAfter": "Số dư ",
    "noRewardRecords": "Chưa có bản ghi",
    "inviteSteps": "Các bước mời",
    "step1": "Chia sẻ link hoặc mã",
    "step2": "Bạn bè được mời hoàn tất xác minh danh tính và đăng ký thẻ qua liên kết hoặc mã mời",
    "step3": "Bạn sẽ nhận được hoa hồng khi bạn bè kích hoạt thẻ"
  },
  "task": {
    "title": "Điểm danh để kiếm điểm",
    "dailyCheckIn": "điểm danh hàng ngày",
    "howToGetPoints": "Cách nhận điểm",
    "myPoints": "Điểm của tôi",
    "dailyTasks": "Nhiệm vụ hằng ngày",
    "checkInTotal": "Checked in for",
    "days": " ngày",
    "checkInRules": "Quy tắc điểm danh",
    "checkInRuleOne": "Sau khi điểm danh hôm nay, hãy nhận vào ngày mai để giữ chuỗi điểm danh.",
    "checkInRuleTwo": "Nếu bạn không nhận giữa chừng, bạn có thể điểm danh lại vào ngày hôm sau để tiếp tục.",
    "moreCheckInsMorePoints": "Điểm danh càng nhiều, càng nhận nhiều điểm",
    "checkedInDaysPrefix": "Đã điểm danh liên tiếp ",
    "checkedInDaysSuffix": " ngày",
    "checkedInTodayTomorrow": "Hôm nay đã điểm danh, nhận vào ngày mai",
    "routineTasks": "Nhiệm vụ thường ngày",
    "dailyPointsLimit": "Daily points limit 1000",
    "basicGrowth": "Tăng trưởng cơ bản",
    "completeSignature": "Hoàn thiện chữ ký",
    "signatureDone": "Hoàn thành chữ ký",
    "pointsPlusOne": "Điểm +1",
    "goFollow": "Đi theo dõi",
    "postMoments": "Đăng lên Moments",
    "perPost": "Mỗi bài đăng",
    "monday": "Mon",
    "tuesday": "Tue",
    "wednesday": "Wed",
    "thursday": "Thu",
    "friday": "Fri",
    "saturday": "Sat",
    "sunday": "Sun"
  },
  "card": {
    "title": "Thẻ",
    "myCards": "Thẻ của tôi",
    "openCard": "Đăng ký thẻ",
    "benefits": "Quyền lợi thẻ",
    "bill": "Hóa đơn",
    "empty": "Chưa có thẻ liên quan",
    "virtualCard": "Thẻ ảo",
    "physicalCard": "Thẻ vật lý",
    "courseCard": "Thẻ khóa học",
    "courseGiftNoticePhysical": "Sau khi mua thẻ vật lý thành công, bạn sẽ nhận được khóa học trực tiếp độc quyền. Liên kết khóa học sẽ được gửi đến email đã đăng ký của bạn; nhấp để xem chi tiết và cách tham gia.",
    "courseGiftNoticeVirtual": "Sau khi mua thẻ ảo thành công, bạn sẽ nhận được khóa học trực tiếp độc quyền. Liên kết khóa học sẽ được gửi đến email đã đăng ký của bạn; nhấp để xem chi tiết và cách tham gia.",
    "applyCard": "Đăng ký thẻ",
    "applyNow": "Apply Now",
    "virtualDesc": "Contactless payments online and offline anytime, anywhere!",
    "physicalDesc": "Không phí thường niên. Rút ATM toàn cầu!",
    "applyCardTypeOne": "Đăng ký thẻ ảo",
    "applyCardTypeTwo": "Đăng ký thẻ vật lý",
    "applyCardTip1": "Đăng ký trực tuyến để thanh toán online và offline",
    "applyCardTip2": "Thẻ vật lý hỗ trợ giao tận nhà, rút ATM và thanh toán POS",
    "applyCardTip3": "Đăng ký trực tuyến, nhận thẻ rồi kích hoạt để sử dụng",
    "applyCardTip4": "Xem và quản lý thẻ ảo và thẻ vật lý",
    "kycDialogTitle": "Xác minh danh tính",
    "kycDialogDesc": "Vui lòng hoàn tất xác minh danh tính để mở khóa tính năng này",
    "kycDialogAction": "KYC ngay",
    "useInstruction": "Hướng dẫn thẻ",
    "virtualCardUseInstruction": "Hướng dẫn sử dụng thẻ ảo",
    "entityCardUseInstruction": "Hướng dẫn sử dụng thẻ vật lý",
    "useInstructionText1": "Thẻ ảo hỗ trợ liên kết Alipay, Meituan và thanh toán trực tuyến.",
    "useInstructionText2": "Thẻ vật lý hỗ trợ Alipay, Meituan, thanh toán online/offline, quẹt POS và rút tiền ATM.",
    "useInstructionText3": "Để bảo vệ tài sản, không chia sẻ số thẻ, ngày hết hạn hoặc CVV cho người khác.",
    "useInstructionText4": "Sau khi hủy liên kết, thẻ không thể khôi phục. Thao tác này không thể hoàn tác.",
    "useInstructionText5": "Sau khi hủy liên kết, phí mở thẻ không được hoàn lại, nhưng số dư còn lại sẽ trả về ví.",
    "useInstructionText6": "Nếu gặp vấn đề, vui lòng vào Tôi - Liên hệ chúng tôi - Hỗ trợ trực tuyến.",
    "useInstructionText7": "Cách liên kết",
    "useInstructionText8": "Alipay",
    "useInstructionText9": "Làm theo các bước dưới đây để liên kết thẻ nhanh chóng và dễ dàng",
    "useInstructionText10": "Mở Alipay",
    "useInstructionText11": "Mở ứng dụng Alipay và nhấn Tôi",
    "useInstructionText12": "Vào Thẻ ngân hàng",
    "useInstructionText13": "Chọn mục thêm thẻ trong Thẻ ngân hàng hoặc Cài đặt thanh toán",
    "useInstructionText14": "Thêm thẻ ngân hàng",
    "useInstructionText15": "Nhấn Thêm thẻ ngân hàng và nhập số thẻ WinPay",
    "useInstructionText16": "Điền thông tin thẻ",
    "useInstructionText17": "Nhập ngày hết hạn, CVV, mã xác minh và các thông tin cần thiết.",
    "useInstructionText18": "Hoàn tất xác minh",
    "useInstructionText19": "Sau khi gửi, hoàn tất xác minh SMS hoặc bảo mật để liên kết thẻ thành công.",
    "useInstructionText20": "Hướng dẫn dùng thẻ",
    "bindCardInfo1": "Thẻ Visa này được chọn cho các tình huống sử dụng Alipay và có thể liên kết nhanh theo các bước sau.",
    "bindCardInfo2": "Thẻ Visa này được chọn cho các tình huống sử dụng Google Pay và có thể liên kết nhanh theo các bước sau.",
    "bindCardInfo3": "Thẻ Visa hỗ trợ Apple Pay. Làm theo các bước sau để liên kết thẻ nhanh chóng.",
    "bindCardInfo4": "Tải xuống và mở Google Pay, sau đó đăng nhập",
    "bindCardInfo5": "Tại trang chủ Google Pay, nhấn Thêm thẻ thanh toán",
    "bindCardInfo6": "Thêm thẻ thanh toán",
    "bindCardInfo7": "Chọn “Thêm thẻ tín dụng hoặc thẻ ghi nợ”.",
    "bindCardInfo8": "Điền thông tin cá nhân",
    "bindCardInfo9": "Điền thông tin thẻ và địa chỉ thanh toán, sau đó nhấn Lưu và tiếp tục",
    "bindCardInfo10": "Mở trang điều khoản của đơn vị phát hành thẻ",
    "bindCardInfo11": "Cuộn xuống dưới cùng và nhấn Tiếp tục",
    "bindCardInfo12": "Chọn “Phương thức xác minh”, nhận và nhập mã xác minh. Sau khi xác minh thành công, thẻ sẽ được liên kết.",
    "bindCardInfo13": "Mở Apple Pay và đăng nhập tài khoản.",
    "bindCardInfo14": "Tại trang chủ Apple Pay, chọn “Thêm thẻ thanh toán”.",
    "bindCardInfo15": "Quét thẻ hoặc nhập thông tin thẻ thủ công.",
    "bindCardInfo16": "Nhập “Số thẻ, Tên tiếng Anh, Ngày hết hạn, Mã bảo mật”.",
    "bindCardInfo17": "Vào trang “Điều khoản & Điều kiện”.",
    "bindCardInfo18": "Cuộn xuống cuối trang và chọn “Đồng ý”.",
    "coreAdvantages": "Ưu điểm cốt lõi",
    "recommendedAudience": "Người dùng được đề xuất",
    "cardScene": "Card Scene",
    "transferIn": "Chuyển vào",
    "transferOut": "Chuyển ra",
    "atmPassword": "Mã ATM",
    "cardInfo": "Thông tin thẻ",
    "mycard": "Thẻ của tôi",
    "benefit": "Quyền lợi thẻ",
    "recentTrade": "Hóa đơn",
    "viewAll": "Tất cả",
    "noTrade": "No trade records",
    "noTradeEmpty": "Chưa có dữ liệu liên quan",
    "inUse": "Đang sử dụng",
    "inactive": "Chưa kích hoạt",
    "frozen": "Đang đóng băng",
    "processing": "Đang xử lý",
    "success": "Thành công",
    "failed": "Thất bại",
    "cardSensitiveTodo": "Sensitive card info flow migration in progress",
    "cardWallet": "Thẻ",
    "cardBenefits": "Quyền lợi thẻ",
    "noBenefit": "No benefit info",
    "withdrawMin": "Min Withdraw",
    "withdrawMax": "Max Withdraw",
    "rechargeMin": "Min Recharge",
    "rechargeMax": "Max Recharge",
    "monthlyLimit": "Monthly Limit",
    "billDetail": "Chi tiết hóa đơn",
    "feeRate": "Payment Fee",
    "chargeFeeLabel": "Phí nạp tiền",
    "rechargeFeeLabel": "Initial Recharge",
    "withdrawFeeLabel": "Phí rút tiền",
    "payFeeLabel": "Phí chi tiêu",
    "selectCardTemplate": "Select Card Template",
    "selectScene": "Select Scene",
    "cardTemplate": "Card Template",
    "scene": "Scene",
    "selectTimeRange": "Chọn khoảng thời gian",
    "timeRangeTip": "Chuyển sang 180 ngày gần nhất để xem chi tiết phần thưởng",
    "last30Days": "30 Ngày Qua",
    "last90Days": "90 Ngày Qua",
    "last180Days": "180 Ngày Qua",
    "currentScenario": "Current Scenario",
    "supportedScenes": "Supported Scenes",
    "supportedPlatforms": "Supported Platforms",
    "platformHint": "Subject to issuer support rules",
    "openCardAmount": "Phí mở thẻ",
    "openCardAmountTip": "Includes issuance fee and initial recharge",
    "openFeeNoticePrefix": "Phí mở thẻ",
    "openFeeNoticeSuffix": "sẽ được nạp vào thẻ để duy trì trạng thái hoạt động của thẻ",
    "firstRechargeTip": "Opening the card requires {amount} {symbol}, plus an initial recharge of {charge} {symbol}",
    "cardTitlePrefix": "Thẻ ",
    "cardUsageLimit": "Spending Limit",
    "monthlyCardUsageLimit": "Hạn mức tiêu thụ/tháng",
    "prepaidCard": "Thẻ trả trước",
    "identityInfo": "Thông tin danh tính",
    "identityInfoTip": "Verified details will be used for card opening checks",
    "firstName": "Tên",
    "lastName": "Họ",
    "identityInfoEmpty": "Please complete verified identity details first",
    "agreementPrefix": "Đã đọc và đồng ý",
    "optionalInvitationCode": "Nhập mã mời (tùy chọn)",
    "openCardNotice": "Opening Notes",
    "openCardNotice1": "The opening cost consists of the issuance fee and initial recharge amount, processed automatically after submission.",
    "openCardNotice2": "Supported platforms and fees vary by scenario and issuing channel. Final rules are subject to the provider.",
    "openCardNotice3": "If you plan to apply for a physical card later, make sure you already hold a bindable virtual card.",
    "termsAgree": "I have read and agree to the User Agreement and Privacy Policy",
    "agreeFirst": "Please agree to the terms first",
    "noCardTemplate": "No card templates are currently available",
    "balanceOverview": "Tổng quan quyền lợi thẻ",
    "withdrawNotice": "Minimum physical card withdrawal {amount} {symbol}",
    "applyPhysicalCard": "Apply Physical Card",
    "physicalApplyDesc": "Verify identity, choose a template, fill shipping information, and wait for card production after payment.",
    "shippingFee": "Shipping",
    "shippingFree": "Free",
    "applicationFee": "Application Fee",
    "applicationFeeLabel": "Phí đăng ký: ",
    "recentTradeScene": "Các tình huống sử dụng được chọn",
    "physicalSceneDesc": "Chi tiêu trực tuyến và ngoại tuyến",
    "physicalOrderNotice": "Physical Card Notes",
    "physicalNotice1": "Open a bindable virtual card before applying for a physical card.",
    "physicalNotice2": "After successful payment, the card enters production and delivery.",
    "physicalNotice3": "Activate the card after receiving it before use.",
    "fillShippingInfo": "Điền thông tin nhận hàng",
    "requireVirtualCardFirst": "Open a bindable virtual card before applying for a physical card",
    "cardInfoTitle": "Thông tin thẻ",
    "shippingInfoTitle": "Thông tin nhận hàng",
    "sameAsVirtualCard": "Giống thẻ ảo",
    "receiverName": "Tên",
    "enterReceiverName": "Nhập",
    "completeAllInfo": "Vui lòng hoàn tất mọi thông tin",
    "addressMinLength": "Địa chỉ phải có ít nhất 5 ký tự",
    "completeShippingAddress": "Complete shipping information. Address must be at least 5 characters.",
    "saveLabel": "Lưu",
    "confirmOrder": "Xác nhận thông tin đơn hàng",
    "payPhysicalCardConfirm": "Confirm the physical card order and proceed to payment?",
    "payNow": "Thanh toán ngay",
    "orderPaid": "Thanh toán thành công",
    "paymentDetail": "Chi tiết thanh toán",
    "paymentFee": "Phí đã thanh toán",
    "paymentSuccess": "Thanh toán thành công",
    "paymentSuccessDesc": "The cua ban dang duoc lam. Du kien giao trong 7-14 ngay lam viec.",
    "physicalCardMakingTip": "Thẻ vật lý mất nhiều thời gian hơn. Hãy kích hoạt sau khi nhận.",
    "paymentAmount": "Phí đã thanh toán",
    "physicalArrivalTip1": "Physical card production usually takes longer. Please wait patiently.",
    "physicalArrivalTip2": "Activate the card first after delivery before using it.",
    "viewPendingCards": "View Pending Cards",
    "totalAssetsInsufficientBalance": "Insufficient total assets. Please top up before continuing.",
    "currentCardInsufficientBalance": "Số dư thẻ không đủ. Vui lòng nạp trước.",
    "topUpNow": "Đi nạp tiền",
    "pendingPhysicalCards": "Thẻ chưa kích hoạt",
    "pendingActivate": "Chưa kích hoạt",
    "noPendingPhysicalCard": "No physical cards pending activation",
    "hasInactiveCards": "Có thẻ chưa kích hoạt",
    "physicalInstruction": "Hướng dẫn thẻ vật lý",
    "pendingNotice1": "You have successfully applied for a physical card. It is now being produced or shipped.",
    "pendingNotice2": "For account security, the physical card cannot be used before activation.",
    "pendingNotice3": "Sau khi nhận thẻ, nhấn nút bên dưới để kích hoạt.",
    "contactSupport": "Liên hệ hỗ trợ",
    "invitationCode": "Mã Mời",
    "enterInvitationCode": "Nhập mã mời (tùy chọn)",
    "openCardConfirm": "Submit card application?",
    "openCardSuccess": "Card application submitted",
    "kycTitle": "Xác minh KYC",
    "kycVerify": "Xác minh KYC",
    "kycRequirement": "Hoàn tất xác minh KYC trước khi đăng ký thẻ.",
    "kycRequirement1": "Provide real and accurate information consistent with your document.",
    "kycRequirement2": "Verification is reviewed by the provider and may take some time.",
    "kycIntroTip": "Submit real identity details first. After approval, you can continue opening a virtual card.",
    "verifyNow": "Xác minh ngay",
    "fillInfo": "Điền thông tin",
    "kycFormTip": "Fill in your usual contact details and billing address exactly as required.",
    "contactAndAddress": "Contact and Address",
    "countryCode": "Mã vùng",
    "selectCountryCode": "Select code",
    "phoneNumber": "Số điện thoại",
    "enterPhone": "Nhập số điện thoại của bạn",
    "address": "Địa chỉ",
    "selectCountry": "Select country",
    "selectCountryRegion": "Chọn quốc gia/khu vực",
    "searchCountry": "Tìm quốc gia",
    "selectRegion": "Select state/province/region",
    "selectCity": "Chọn thành phố",
    "enterAddress": "Enter detailed address",
    "postalCode": "Mã bưu chính",
    "enterPostalCode": "Enter postal code",
    "completeKycAddress": "Complete address info. Address must be at least 5 characters.",
    "kycSubmitted": "Information submitted",
    "kycReview": "Xét duyệt thông tin",
    "kycRejected": "Xác minh KYC bị từ chối",
    "kycPending": "Thông tin đã gửi, đang chờ xét duyệt",
    "kycApproved": "Thông tin đã được duyệt",
    "kycRejectedTip": "Please revise the information according to the rejection reason and resubmit.",
    "reviewTip": "Review finished, select a card to activate",
    "reviewDone": "tôi biết rồi",
    "cardCanOpen": "Giờ bạn có thể chọn thẻ",
    "resubmit": "Gửi lại",
    "failedReason": "Lý do thất bại",
    "activatePending": "{count} physical cards pending activation",
    "oldCardTransferTip": "Legacy cards do not support transfer in / out after the WinPay card service upgrade.",
    "oldCardServiceUpgradeNotice": "Vui lòng kiểm tra lại sau khi hoàn tất nâng cấp dịch vụ thẻ cũ.",
    "cardProcessingWait": "Card is still processing. Please try again later.",
    "cardBalance": "Card Balance",
    "accountBalance": "Funding Balance",
    "availableBalanceLabel": "Số dư khả dụng:",
    "rechargeCurrencyTitle": "Tiền tệ nạp tiền",
    "rechargeAmountTitle": "Số tiền nạp",
    "monthlyFee": "Phí hàng tháng",
    "supportedConsumptionScenes": "Các tình huống tiêu dùng được hỗ trợ",
    "keySupportedPlatforms": "Nền tảng chính được hỗ trợ",
    "allSupportedPlatforms": "Tất cả nền tảng được hỗ trợ",
    "otherServices": "Other Services",
    "otherPlatforms": "Dịch vụ khác",
    "cardUsageRules": "Quy tắc sử dụng thẻ",
    "usageRule1": "Tỷ lệ hoàn tiền, tỷ lệ hủy, tỷ lệ thất bại và tỷ lệ xác thực cao có thể gây ra rủi ro khóa thẻ",
    "usageRule2": "Cấm sử dụng trên các nền tảng như Steam, Blizzard, EA, Battle.net, OYSTER LABS",
    "usageRule3": "Cấm liên kết các nền tảng đăng ký với thanh toán tự động",
    "cardSafetyTips": "Lời khuyên an toàn khi sử dụng thẻ",
    "cardSafetyTip1": "Không chia sẻ số thẻ, ngày hết hạn, CVV và các thông tin khác với người khác",
    "cardSafetyTip2": "Vui lòng sử dụng thẻ trả trước một cách hợp pháp và trong phạm vi tuân thủ quy định của thẻ.",
    "unbindCard": "Hủy liên kết thẻ",
    "unBindCardText_1": "Before unbinding your card, please note the balance on the card:",
    "unBindCardText_2": "Any card balance will be refunded to your account within 1-7 business days after unbinding. Check history or contact support.",
    "unBindCardText_3": "The following impacts will occur after unbinding",
    "unBindCardText_4": "This card will no longer be available for payments or related transactions",
    "unBindCardText_5": "Automatic payment services linked to this card may be affected",
    "unBindCardText_6": "After unbinding, this card cannot be bound again",
    "unBindCardText_7": "Unbinding in progress",
    "unBindCardText_8": "Unbinding card...",
    "unBindCardText_9": "Please wait, it is expected to take two minutes",
    "unBindCardText_10": "To protect your funds, unbinding cannot be reversed",
    "unBindCardText_11": "Unbound successfully",
    "unBindCardText_12": "Card unbound successfully",
    "unBindCardText_13": "Your card has been successfully unbound and will no longer appear in the card list",
    "unBindCardText_14": "Unbinding failed",
    "unBindCardText_15": "Card unbinding failed",
    "unBindCardText_16": "Failed to unbind this card. Please try again later or contact support.",
    "unBindCardText_17": "Unbound cards",
    "unBindCardText_18": "Unbound",
    "unBindCardText_19": "Unbound card details",
    "unBindCardText_20": "Remaining amount when unbinding the card:",
    "unBindCardText_21": "Was the refund of the remaining amount successful:",
    "unBindCardText_22": "Card unbinding time:",
    "unbindCardStatus": "Card status",
    "unbindRefundYes": "Yes",
    "unbindRefundPending": "Processing",
    "minAmount": "Minimum Amount",
    "exchangeRate": "Giá hiện tại",
    "chargeArrivalTitle": "Số tiền nạp vào",
    "expectedCardArrival": "Dự kiến nhận được",
    "expectedAccountArrival": "Tiền đã rút",
    "submitTransfer": "Xác nhận",
    "transferSuccess": "Chuyển đã gửi",
    "transferSuccessTitle": "Mẹo",
    "transferInSuccessDesc": "Chúc mừng bạn, bạn đã nạp tiền thành công",
    "transferOutSuccessDesc": "Chúc mừng, bạn đã rút tiền thành công",
    "enterChargeAmount": "Nhập số tiền nạp",
    "enterTransferInAmount": "Enter transfer in amount",
    "enterTransferOutAmount": "Enter transfer out amount",
    "enterValidAmount": "Enter a valid amount",
    "tradeDetail": "Chi tiết",
    "tradeProcessingTip": "This transaction is still processing. Check back later for the final result.",
    "cardNumber": "Số thẻ",
    "tradeType": "Loại giao dịch",
    "tradeDescription": "Ghi chú",
    "merchant": "Merchant",
    "amount": "Amount",
    "tradeAmount": "Số tiền giao dịch",
    "orderNumber": "Order Number:",
    "orderId": "Order ID",
    "tradeTime": "Thời gian",
    "noTradeDetail": "No trade detail available",
    "cvvTip": "The CVV is the 3 or 4 digit code on the back of the card used to verify your identity.",
    "sensitiveInfoLocked": "Wallet password verification is required before viewing the card number, expiry date, and CVV.",
    "sensitiveInfoLockedDesc": "For account safety, sensitive card information stays hidden until verification succeeds.",
    "unlockNow": "Verify and Unlock",
    "myCard": "Thẻ của tôi",
    "basicInfo": "Thông tin thẻ",
    "cardType": "Loại thẻ",
    "cardholder": "Chủ thẻ",
    "phoneNumberLabel": "Số điện thoại",
    "validThru": "Valid Thru (MM/YY)",
    "validThroughLabel": "Hiệu lực đến",
    "cvvCode": "CVV",
    "openSecurePage": "Open secure page in new window",
    "openVerificationPage": "Open verification page",
    "checkVerificationStatus": "Check verification status",
    "verificationPageUnavailable": "Verification page is unavailable for now. Please check the status later.",
    "diditSdkTitle": "Didit Face Verification",
    "sdkIdle": "Not started",
    "sdkLoading": "Loading verification",
    "sdkReady": "Verification in progress",
    "sdkUnavailable": "Failed to load Didit SDK. Open it externally instead.",
    "sdkCancelled": "KYC verification was cancelled",
    "sdkDeclined": "KYC verification was declined",
    "restartVerification": "Restart verification",
    "sdkCurrentStep": "Current Step",
    "sdkLastEvent": "Last Event",
    "sdkStepDocumentSelection": "Select document type",
    "sdkStepDocumentFront": "Capture document front",
    "sdkStepDocumentBack": "Capture document back",
    "sdkStepFace": "Face verification",
    "sdkStepEmail": "Email verification",
    "cameraPermissionTitle": "Enable Camera Permission",
    "cameraPermissionTip": "Document capture and face verification require browser camera access. Please grant camera permission first.",
    "cameraPermissionDenied": "Camera permission is not available right now. Please allow camera access in your browser settings before continuing.",
    "cameraPermissionGranted": "Camera permission is ready. You can continue with document capture and face verification.",
    "cameraPermissionGrantedToast": "Camera permission enabled",
    "cameraPermissionOpen": "Enable",
    "cameraPermissionReady": "Enabled",
    "cameraPermissionDialog": "Browser camera permission is currently unavailable. Please allow camera access from the browser address bar or system settings, then continue with KYC verification.",
    "sdkStepPhone": "Phone verification",
    "sdkStepPoa": "Proof of address",
    "sdkStepQuestionnaire": "Questionnaire",
    "sdkEventReady": "Verification page ready",
    "sdkEventStarted": "Verification started",
    "sdkEventStepStarted": "Step started",
    "sdkEventStepCompleted": "Step completed",
    "sdkEventStepChanged": "Step changed",
    "sdkEventMediaStarted": "Capture started",
    "sdkEventMediaCaptured": "Capture completed",
    "sdkEventDocumentSelected": "Document selected",
    "sdkEventSubmitted": "Verification submitted",
    "sdkEventCodeSent": "Code sent",
    "sdkEventCodeVerified": "Code verified",
    "sdkEventStatusUpdated": "Status updated",
    "sdkEventCompleted": "Verification completed",
    "sdkEventCancelled": "Verification cancelled",
    "sdkEventError": "Verification error",
    "sdkEventCloseRequest": "Close requested",
    "kycTokenEmpty": "KYC token is empty. Please try again later.",
    "viewAtmPassword": "Xem mã ATM",
    "enterAtmPassword": "Enter 6-digit ATM PIN",
    "confirmAtmPassword": "Xác nhận mã ATM",
    "atmPasswordTip": "*Mật khẩu này chỉ đặt được một lần và có thể xem lại.",
    "sixDigitPin": "Enter a 6-digit numeric PIN",
    "setPinSuccess": "Đặt mật khẩu thành công",
    "GoOpenCard": "Mở thẻ"
  },
  "mine": {
    "title": "Tài khoản của tôi",
    "mineCode": "Mã QR của tôi",
    "scanAddFriend": "Scan to add as WinPay Wallet friend",
    "wallet": "Quản lý ví",
    "cardCodeRedemption": "Đổi mã thẻ",
    "enterCardCode": "Nhập mã thẻ",
    "security": "Cài đặt an toàn",
    "language": "Chuyển đổi ngôn ngữ",
    "selectLanguage": "Ngôn ngữ",
    "contactUs": "Liên hệ",
    "about": "Về chúng tôi",
    "kyc": "Xác minh KYC",
    "userId": "User ID",
    "login": "Login/Register",
    "logout": "Đăng xuất tài khoản",
    "logoutConfirm": "Log out of the current account?",
    "logoutConfirmTitle": "Xác nhận đăng xuất?",
    "logoutConfirmAccount": "Bạn có chắc muốn đăng xuất khỏi tài khoản hiện tại [{name}] không?",
    "points": "Điểm",
    "currentLevel": "Cấp hiện tại",
    "totalPoints": "Tổng điểm",
    "nextLevelPoints": "{points} points to the next level",
    "levelSurpassed": "Current level exceeded",
    "maxLevelReached": "Maximum level reached",
    "exclusiveLevel": "Cấp độc quyền",
    "dailyCheckInPoints": "Điểm danh hằng ngày nhận điểm",
    "rewardDetails": "Phần thưởng",
    "signIn": "Điểm danh",
    "signedIn": "Đã điểm danh",
    "checkInSuccess": "Check-in successful, earned {reward} points",
    "gameZone": "Khu trò chơi",
    "gameDesc": "Dễ dàng kiếm điểm",
    "shopZone": "Khu thương mại điện tử",
    "shopDesc": "Đặt hàng để nhận điểm",
    "enterZone": "Enter",
    "inviteFriends": "Mời bạn",
    "inviteDesc": "Invite friends to WinPay",
    "invitedUsers": "Invited registered wallets",
    "recommender": "Inviter",
    "bindSuccess": "Lien ket thanh cong",
    "takePhoto": "Chụp ảnh",
    "chooseFromAlbum": "Choose from Library",
    "avatarUpdated": "Avatar updated",
    "avatarUploadFailed": "Avatar upload failed. Please try again later.",
    "avatarImageOnly": "Please choose an image file",
    "avatarImageTooLarge": "Image size must be under {size}MB",
    "changeWalletName": "Rename Wallet",
    "enterWalletName": "Nhập tên ví",
    "nameTooLong": "Name cannot exceed 16 characters",
    "nameUpdated": "Name updated",
    "securityTodo": "Security settings migration in progress",
    "kycTodo": "Xác minh ngay",
    "kycPending": "Pending",
    "kycVerified": "Đã xác minh",
    "kycFailed": "Thất bại",
    "kycTodoDesc": "Hoàn tất xác minh KYC trước khi tiếp tục sử dụng tính năng thẻ ảo hoặc thẻ vật lý.",
    "kycPendingDesc": "Your verification materials have been submitted and are under review.",
    "kycVerifiedDesc": "Xác minh KYC đã hoàn tất và tài khoản này có thể dùng các chức năng xác minh liên quan đến thẻ.",
    "kycFailedDesc": "Verification was not approved. Please review the reason and submit again.",
    "viewKycResult": "View Result",
    "retryKyc": "Retry Verification",
    "aboutDesc": "One-stop Web3 social and payment wallet",
    "version": "Version",
    "contactDesc": "If you have any questions, such as wallet deletion or usage issues, please contact us through the following methods:",
    "supportEmail": "Email chăm sóc khách hàng",
    "onlineSupport": "Chăm sóc khách hàng trực tuyến",
    "serviceMailbox": "Customer Service Mailbox",
    "serviceHours": "Support Hours",
    "weekdayHours": "Working Days: 09:00 AM - 06:00 PM",
    "supportReplyTip": "Chúng tôi sẽ phản hồi trong giờ làm việc.",
    "supportThanks": "Thank you for your support and understanding."
  },
  "article": {
    "square": "vuông",
    "followTab": "Theo dõi",
    "likeTab": "Bộ sưu tập",
    "nowTab": "instant",
    "create": "Xuất bản",
    "myArticle": "My Articles",
    "detail": "Article Detail",
    "addToken": "Thêm token",
    "addNft": "Thêm NFT",
    "reportTitle": "Báo cáo",
    "reportSuccess": "Thanks for your feedback.",
    "reportFailed": "Submit failed. Thử lại sau.",
    "reasonAttack": "Tấn công và kích động",
    "reasonPorn": "Khiêu dâm và tục tĩu",
    "reasonDiscomfort": "Không thoải mái",
    "reasonSpam": "Quảng cáo rác",
    "follow": "theo dõi",
    "followed": "Đã theo dõi",
    "followSuccess": "Đã theo dõi",
    "unfollowSuccess": "Đã hủy theo dõi",
    "likeSuccess": "Liked",
    "unlikeSuccess": "Unliked",
    "now": "chỉ",
    "minutesAgo": "phút trước",
    "hoursAgo": "giờ trước",
    "daysAgo": "Ngày trước",
    "views": "Views",
    "forwarded": "Chuyển tiếp",
    "empty": "No content",
    "searchPlaceholder": "Tìm kiếm",
    "unsupportedNetwork": "The current network does not support home content.",
    "switchNetwork": "Chuyển mạng",
    "observerWalletWarn": "Watch-only wallets cannot access home content.",
    "switchWallet": "Switch Wallet",
    "openDetailTodo": "Article detail is pending migration",
    "createTodo": "Article publishing is pending migration",
    "addTokenTodo": "Add token is pending migration",
    "addNftTodo": "Add NFT is pending migration",
    "sampleName": "WinPay User",
    "sampleTopic": "Flutter article module migration preview",
    "sampleContent": "This page carries the migrated H5 styles, state, and sheet interaction for article modules."
  }
};
